import * as T from './ServicesLinks.types';

import css from './ServicesLinks.module.scss';

import { AnalyticsEvent } from 'utils/analytics';

export const SERVICES: Array<T.IService> = [
  {
    link: '/events',
    testId: 'Event-main',
    title: 'Мероприятия',
    class: css.events,
    analyticEvent: AnalyticsEvent.CLICK_ON_BOX_EVENTS,
  },
  {
    link: '/cinema',
    testId: 'Cinema-main',
    title: 'Кинотеатр',
    class: css.films,
    analyticEvent: AnalyticsEvent.CLICK_ON_BOX_FILMS,
  },
  {
    link: '/library',
    title: 'Лекции',
    class: css.lectures,
    analyticEvent: AnalyticsEvent.CLICK_ON_BOX_LECTURES,
  },
  {
    link: 'https://znanierussia.ru/articles/',
    title: 'Статьи',
    class: css.articles,
    analyticEvent: AnalyticsEvent.CLICK_ON_BOX_ARTICLES,
  },
  {
    link: 'https://akademiya.znanierussia.ru/',
    title: 'Курсы',
    class: css.courses,
    analyticEvent: AnalyticsEvent.CLICK_ON_BOX_COURSES,
  },
  {
    link: '/become-speaker',
    title: 'Стать Лектором',
    class: css.speakers,
    analyticEvent: AnalyticsEvent.CLICK_ON_BOX_BECOME_SPEAKER,
  },
];
